import { PayloadAction } from '@reduxjs/toolkit'
import api from '../../agent'
import create from './base'

export interface DashboardState {
    value: number;
    data: {
        win_rate_data: any[],
        projects: any[],
        strategies: any[]
    }
}

const DashboardRedux = create('dashboard', {
    value: 0,
    data: {
        win_rate_data: [],
        projects: [],
        strategies: []
    }
}, {
    increment: (state: DashboardState) => {
        state.value += 1
    },
    decrement: (state: DashboardState) => {
        state.value -= 1
    },
    incrementByAmount: (state: DashboardState, action: PayloadAction<number>) => {
        state.value += action.payload
    }
}, {
    getDashboard: async (state: DashboardState) => {
        const response = await api.getDashboard()

        return {
            data: response.data
        }
    }
})

export const {
    increment,
    decrement,
    incrementByAmount,
    getDashboard
} = DashboardRedux.actions

export default DashboardRedux.reducer
